<template>
  <div class="achievement">
    <div class="tab">
      <!-- <span :class="activeTab==1?'activeTab':''" @click="tab(1)">考试证书</span> -->
      <span :class="activeTab==2?'activeTab':''"
            @click="tab(2)">作业成就卡</span>
    </div>
    <div class="carList">
      <div v-for="item in list"
           :key="item.amId"
           @click="goTo(item)">
        <img src="../../assets/images/zhengshu.png"
             alt />
        <span class="item-num">85</span>
        <span class="item-content">{{getTimes(item.amCreateDate)}}取得</span>
      </div>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      activeTab: 2,
      wxuser: null,
      list: []
    };
  },
  props: {},
  async mounted () {
    this.wxuser= await loginService.getLoginUser();
    document.title = "我的证书";
    this.getList();
  },
  methods: {
    tab (val) {
      this.activeTab = val;
      this.getList();
    },
    goTo (item) {
      this.$router.push({
        name: "AchieveCar",
        query: {
          amUid: item.amUId,
          amVid: item.amVId
        }
      });
    },
    getTimes (value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd");
    },
    getList () {
      this.$postHttp(AppSetting.baseUrl + "/achievement/app/list", {
        amUId: this.wxuser.uId,
        amType: this.activeTab
      }).then(res => {
        if (res.data.code == 0) {
          this.list = res.data.list;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;
  .tab {
    width: 100%;
    display: flex;
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
    padding: 0px 0.3rem;
    box-sizing: border-box;
    span {
      flex: 1;
      padding: 0px 0.15rem;
      box-sizing: border-box;
    }
  }
  .activeTab {
    color: #05a2ff;
    font-size: 0.34rem;
    border-bottom: 0.01rem solid #05a2ff;
  }
  .carList {
    // display: flex;
    padding: 0.35rem 0.3rem;
    overflow: hidden;
    // flex-wrap: wrap;
    // justify-content: center;
    // align-content:flex-start;
    div {
      // width: 30%;
      float: left;
      font-size: 0.26rem;
      color: #333;
      width: calc((100% - 0.3rem) / 3);
      // background: #FFF;
      margin-top: 0.33rem;
      position: relative;
      text-align: center;
      margin-right: 0.15rem;
      img {
        width: 100%;
      }
      .item-content {
        margin-top: 0.3rem;
      }
      .item-num {
        position: absolute;
        font-size: 0.42rem;
        color: #f39800;
        top: 0.5rem;
        left: 0.2rem;
      }
    }
    .noMargin {
      margin-right: 0rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/achievement.vue